<header-title [model]="headerTitle"></header-title>

<div class="row">
    <div class="col-md-1">
        <button class="btn btn-primary" type="button" [routerLink]="['/audit/audittype/add']">Add New Audit Type</button>
    </div>
</div>

<section class="panel">
    <div class="row">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h2 class="panel-title">Existing Audit Types</h2>
            </header>
        </div>
        <div class="col col-md-6 pt-3">
            <div class="row" style="align-items:flex-end;">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <!--<th>Actions</th>-->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let auditType of auditTypeList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{auditType.name}}</td>
                        <!--<td class="actions">
                            <a [routerLink]="['/module', module.id]" class="mb-1 mt-1 mr-2"><i class="fas fa-edit"></i></a>
                        </td>-->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
